/**
 * 集中管理所有请求导出
 * 提供组合式API和函数式API风格的访问方式
 */

// 导入请求管理器
import requestManager from './manager';

// 导入各模块的函数式API
import * as userAPI from './modules/user';
import * as reportAPI from './modules/report';

// 导出所有函数式API
export const user = userAPI;
export const report = reportAPI;
// 导出park实例API
export const park = requestManager.park;

// 导出单独的请求实例（兼容旧API）
export const userRequest = requestManager.user;
export const systemRequest = requestManager.system;
export const parkRequest = requestManager.park;
export const reportRequest = requestManager.report;
export const serviceRequest = requestManager.service;

/**
 * 获取用户相关请求实例
 * @returns {UserRequest} 用户请求实例
 */
export function useUserRequest() {
  return requestManager.user;
}

/**
 * 获取系统相关请求实例
 * @returns {SystemRequest} 系统请求实例
 */
export function useSystemRequest() {
  return requestManager.system;
}

/**
 * 获取园区相关请求实例
 * @returns {ParkRequest} 园区请求实例
 */
export function useParkRequest() {
  return requestManager.park;
}

/**
 * 获取提报相关请求实例
 * @returns {ReportRequest} 提报请求实例
 */
export function useReportRequest() {
  return requestManager.report;
}

/**
 * 获取服务相关请求实例
 * @returns {ServiceRequest} 服务请求实例
 */
export function useServiceRequest() {
  return requestManager.service;
}

/**
 * 获取所有请求实例
 * @returns {Object} 包含所有请求实例的对象
 */
export function useRequests() {
  return {
    user: requestManager.user,
    system: requestManager.system,
    park: requestManager.park,
    report: requestManager.report,
    service: requestManager.service
  };
}

/**
 * 创建一个新的用户请求实例
 * @returns {UserRequest} 新的用户请求实例
 */
export function createUserRequest() {
  const UserRequest = requestManager.user.constructor;
  return new UserRequest();
}

/**
 * 创建一个新的系统请求实例
 * @returns {SystemRequest} 新的系统请求实例
 */
export function createSystemRequest() {
  const SystemRequest = requestManager.system.constructor;
  return new SystemRequest();
}

/**
 * 创建一个新的园区请求实例
 * @returns {ParkRequest} 新的园区请求实例
 */
export function createParkRequest() {
  const ParkRequest = requestManager.park.constructor;
  return new ParkRequest();
}

/**
 * 创建一个新的提报请求实例
 * @returns {ReportRequest} 新的提报请求实例
 */
export function createReportRequest() {
  const ReportRequest = requestManager.report.constructor;
  return new ReportRequest();
}

/**
 * 创建一个新的服务请求实例
 * @returns {ServiceRequest} 新的服务请求实例
 */
export function createServiceRequest() {
  const ServiceRequest = requestManager.service.constructor;
  return new ServiceRequest();
} 